import curd from '../curd'

const BASE_PATH = '/related/factor'

export default curd(BASE_PATH, {
  getAllList: () => ({
    url: `${BASE_PATH}/list`,
    method: 'GET'
  })
})



// WEBPACK FOOTER //
// ./src/apis/modules/RelatedFactor.js